import React from "react";
import {getEnigooTurnstileType} from "../enigooTurnstileHelper";
import ETable, {EditIconBtn} from "../components/Table";

const TurnstileTemplateTable = ({data}) => {
    const columns = [
        {header: "#ID",           key: "id"},
        {header: "Název",         key: "name"},
        {header: "Typ",           render: row => getEnigooTurnstileType(row.type)},
        {header: "Poslední změna",key: "lastChange"},
        {header: "Možnosti",      render: row => <EditIconBtn to={"/turnstile/template/detail/" + row.id}/>},
    ];

    return <ETable columns={columns} data={data}/>;
};

export default TurnstileTemplateTable;
